// ФАЙЛ: types.ts
// НАЗНАЧЕНИЕ: Типы зонной модели компоновки overlay — идентификаторы зон
// и параметры регистрации виджета в слоте зоны.

/**
 * Именованные зоны экрана. Центр (middle-center) сознательно не включён —
 * туда позиционируемые виджеты не кладут (занят контентом стрима).
 */
export type ZoneId =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'middle-left'
  | 'middle-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right'

/** Полный упорядоченный список зон — для рендера сетки и валидации. */
export const ZONE_IDS: readonly ZoneId[] = [
  'top-left',
  'top-center',
  'top-right',
  'middle-left',
  'middle-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
] as const

/** Проверка, что произвольная строка — валидный ZoneId. */
export function isZoneId(value: unknown): value is ZoneId {
  return typeof value === 'string' && (ZONE_IDS as readonly string[]).includes(value)
}

/**
 * Параметры регистрации виджета в зоне. widgetId — стабильный id
 * (например `poll_${sessionId}`) для дедупликации без ремаунта.
 * priority — выше значит ближе к якорю зоны при стекировании.
 */
export interface ZoneSlotOptions {
  widgetId: string
  zone: ZoneId
  priority?: number
}
